var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"spinnerWrapper"},[_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('b-spinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }